var _path, _path2, _rect, _rect2, _rect3, _path3, _rect4, _path4, _path5, _rect5, _rect6, _path6, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgHostingHardware = function SvgHostingHardware(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.428 37.538a.575.575 0 0 0 .572-.576v-3.808c0-.637-.512-1.154-1.144-1.154H4.144C3.512 32 3 32.517 3 33.154v8.77c1.011 0 1.83.826 1.83 1.845v.462c0 1.02-.819 1.846-1.83 1.846v8.77C3 55.482 3.512 56 4.144 56h51.712c.632 0 1.144-.517 1.144-1.154V51.04a.575.575 0 0 0-.572-.578h-3.174v-1.846h3.174a.574.574 0 0 0 .572-.577v-8.076a.574.574 0 0 0-.572-.577h-3.174v-1.846h3.174Z",
    fill: "#DFE4EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.384 37.538c.34 0 .616-.258.616-.576v-3.808c0-.637-.552-1.154-1.233-1.154H55v24h.767c.681 0 1.233-.517 1.233-1.154V51.04c0-.32-.276-.578-.616-.578H55v-1.846h1.384c.34 0 .616-.258.616-.577v-8.076c0-.32-.276-.577-.616-.577H55v-1.846h1.384Z",
    fill: "#FEDB01"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 36,
    width: 10,
    height: 16,
    rx: 2,
    fill: "#C7CED9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 36,
    width: 10,
    height: 16,
    rx: 2,
    fill: "#8FC2FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 36,
    width: 19,
    height: 16,
    rx: 2,
    fill: "#5A9DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 46c-1.106 0-2-.894-2-2 0-1.106.894-2 2-2a2 2 0 0 1 0 4Z",
    fill: "#345795"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 43,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.428 9.538A.574.574 0 0 0 44 8.962V5.154C44 4.517 43.488 4 42.856 4H4.144C3.512 4 3 4.517 3 5.154v8.77c1.011 0 1.83.826 1.83 1.845v.462c0 1.02-.819 1.846-1.83 1.846v8.77C3 27.482 3.512 28 4.144 28h38.712c.632 0 1.144-.517 1.144-1.154v-3.808a.575.575 0 0 0-.572-.576h-3.174v-1.847h3.174A.574.574 0 0 0 44 20.04V11.96a.574.574 0 0 0-.572-.576h-3.174V9.538h3.174Z",
    fill: "#DFE4EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.384 9.538c.34 0 .616-.258.616-.576V5.154C44 4.517 43.448 4 42.767 4H42v24h.767c.681 0 1.233-.517 1.233-1.154v-3.808c0-.318-.276-.576-.616-.576H42v-1.847h1.384c.34 0 .616-.258.616-.576V11.96c0-.318-.276-.576-.616-.576H42V9.538h1.384Z",
    fill: "#FEDB01"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 8,
    width: 10,
    height: 16,
    rx: 2,
    fill: "#C7CED9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 8,
    width: 19,
    height: 16,
    rx: 2,
    fill: "#5A9DFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21c-1.106 0-2-.894-2-2 0-1.106.894-2 2-2a2 2 0 0 1 0 4zm0-6c-1.106 0-2-.894-2-2 0-1.106.894-2 2-2a2 2 0 0 1 0 4z",
    fill: "#345795"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 20,
    width: 8,
    height: 2,
    rx: 1,
    transform: "rotate(-90 29 20)",
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 20,
    width: 8,
    height: 2,
    rx: 1,
    transform: "rotate(-90 33 20)",
    fill: "#fff"
  })));
};

export default SvgHostingHardware;